module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":{"notSL":"Please provide the start and end dates of Candidate\u0027s permission to stay in the UK","sl":"Do you really want to approve this case?"},"placeholder":{"startDate":"Start date","endDate":"End date"},"buttons":{"confirm":"Approve the case and confirm the dates","ok":"OK"}}}')
  delete Component.options._Ctor
}
